import { useState, useEffect, useCallback, useRef } from "react";
import DashSearchHeader from "../../part/header.search.dashboard";
import { Link, useParams } from "react-router-dom";
import "../../app.css"

import axios from 'axios';

import { LuUser } from "react-icons/lu";
import { LuUserCheck } from "react-icons/lu";

import { TbCameraPlus } from "react-icons/tb";
import { Country, State } from 'country-state-city'; // Removed City as it was unused

import PlaceholderImage from '../../image/icons.png';
import { LiaDiceThreeSolid } from "react-icons/lia";
import TutorDashMenu from "../../part/tutor_dash_menu";
import ModifyStudent from "../../part/modifyStudent";


const initialFormData = {
    id: null,
    firstname: "",
    lastname: "",
    middle_name: "",
    email: "",
    phone: "",
    address: "",
    gender: "",
    specialisation: "",
    venue: "",
    selectedImage: null,
    error: "",
    selectedCountry: null,
    selectedState: null,
    states: [],
};


const StudentList = () => {
    // --- Initial Menu Cover Width Logic (Kept as is) ---
    const getInitialMenuCoverWidth = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    };

    const [menuCoverWidth, setMenuCoverWidth] = useState(getInitialMenuCoverWidth());
    const { student_id } = useParams();
    
    const fileInputRef = useRef(null);

    const [appliedUsers, setAppliedUsers] = useState([]);
    const [activeModifier, setActiveModifier] = useState(false);
     const [ModStudentID, setModStudentID] = useState(null);
    const [formData, setFormData] = useState(initialFormData);

    // --- Country/State Data Helpers ---
    const countries = Country.getAllCountries();

    // Helper function to find the ISO code from a country name string
    const getCountryIsoCode = (countryName) => {
        if (!countryName) return null;
        const normalizedName = countryName.trim().toLowerCase();
        const country = countries.find(
            c => c.name.toLowerCase() === normalizedName
        );
        return country ? country.isoCode : null;
    };

    // 🎯 FIX: Wrap setStudentDataToForm in useCallback
    const setStudentDataToForm = useCallback((student) => {

        let studentCountryCode = null;
        let studentStateCode = null;
        let displayAddress = student.address || "";
        let parts = [];

        if (displayAddress) {
            parts = displayAddress.split(',').map(p => p.trim());
            const potentialCountryName = parts[parts.length - 1];
            studentCountryCode = getCountryIsoCode(potentialCountryName);
        }

        const studentStates = studentCountryCode ? State.getStatesOfCountry(studentCountryCode) : [];

        if (studentCountryCode && studentStates.length > 0 && parts.length > 1) {
            const potentialStateName = parts[0];
            const foundState = studentStates.find(s => s.name.toLowerCase() === potentialStateName?.toLowerCase());
            if (foundState) {
                studentStateCode = foundState.isoCode;
            }
        }

        setFormData({
            id: student.id,
            firstname: student.first_name || "",
            lastname: student.last_name || "",
            middle_name: student.middle_name || "",
            email: student.email || "",
            phone: student.phone_number || "",
            address: displayAddress,
            gender: student.gender || "",
            specialisation: student.specialisation || "",
            venue: student.venue || "",
            selectedImage: `https://geoinfoacademy.com/${student.profile_picture}` || null,
            error: "",
            selectedCountry: studentCountryCode,
            selectedState: studentStateCode,
            states: studentStates,
        });
    }, [countries]); // Dependencies: 'countries' (static, but technically used)

    // 🎯 FIX: Add setStudentDataToForm to the dependency array
    // const fetchAppliedUser = useCallback(async () => {
    //     const accessToken = localStorage.getItem("accessToken");
    //     if (!accessToken) {
    //         window.location.href = "/";
    //         return;
    //     }

    //     try {
    //         const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/all-students/", {
    //             headers: {
    //                 Authorization: `Bearer ${accessToken}`,
    //             },
    //         });

    //         const students = response.data || [];
    //         setAppliedUsers(students);

    //         // Set the first student's info as the default display data
    //         if (students.length > 0) {
    //             setStudentDataToForm(students[0]);
    //         }

    //     } catch (error) {
    //         if (error.response && error.response.status === 401) {
    //             localStorage.removeItem("accessToken");
    //             localStorage.removeItem("user");
    //             window.location.href = "/";
    //         } else {
    //             console.error("Error fetching data:", error);
    //             setFormData(prev => ({ ...prev, error: "Failed to load student data." }));
    //         }
    //     }
    // }, [setStudentDataToForm]);





    // this is for the selected student 
    const fetchAppliedUser = useCallback(async () => {
        const accessToken = localStorage.getItem("accessToken");

        if (!accessToken) {
            window.location.href = "/";
            return;
        }

        // Guard clause: Don't fetch if student_id is missing
        if (!student_id) return;
        console.log("student id",student_id )
        try {
            // 2. Updated URL to target a specific student
            const response = await axios.get(`https://api.geoinfoacademy.com/api/tutor/student-details/?student_id=${student_id}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            const student = response.data;
            console.log(student)
            // 3. Update your state with the single object returned
            if (student) {
                setStudentDataToForm(student.student_info);
                // If you still need this for other UI parts, wrap it in an array
                setAppliedUsers(student);
            }

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/";
            } else {
                console.error("Error fetching data:", error);
                setFormData(prev => ({ ...prev, error: "Failed to load student data." }));
            }
        }
        // 4. Added student_id to the dependency array
    }, [student_id, setStudentDataToForm]);


    // // 🎯 INITIAL LOAD: Runs fetchAppliedUser only once on mount
    useEffect(() => {
        fetchAppliedUser();
    }, [fetchAppliedUser]);




    // 🎯 HANDLER: To update the displayed profile when a student in the sidebar is clicked
    const handleStudentClick = (studentId) => {
        const selectedStudent = appliedUsers.find(student => student.id === studentId);
        if (selectedStudent) {
            setStudentDataToForm(selectedStudent);
        }
    };

    // --- Other Handlers (kept simple) ---
    const handleInputChange = (event) => { /* Disabled inputs */ };
    const handleCountryChange = (event) => { /* Disabled inputs */ };
    const handleFileChange = (event) => { /* Disabled inputs */ };
    const handleButtonClick = () => { fileInputRef.current.click(); };
    const handleDragOver = (event) => { event.preventDefault(); };
    const handleDrop = (event) => { /* Disabled inputs */ };

    // --- Resize Logic (Kept as is) ---
    const handleResize = useCallback(() => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            setMenuCoverWidth(menuCover.offsetWidth);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);




    const IdentifyStudent = (id) =>{
        setModStudentID(id)
        setActiveModifier(true)
    }
    const RemoveModifier = (id) =>{
        setModStudentID(null)
        setActiveModifier(false)
    }


    // 🎯 JSX Mapping: Creates the list of clickable students
    // const AppliedUserList = appliedUsers.length > 0 ? appliedUsers.map(list => {
    //     const isSelected = list.id === formData.id;

    //     return (
    //         <li
    //             key={list.id}
    //             className={isSelected ? "active" : ""}
    //             onClick={() => handleStudentClick(list.id)}
    //         >
    //             {isSelected ? <LuUserCheck /> : <LuUser />}
    //             {list.first_name} {list.last_name}
    //         </li>
    //     )
    // }) : <li style={{ padding: '10px', textAlign: 'center', color: '#888' }}>No students found.</li>;



    const examlist = appliedUsers?.exams_taken?.length > 0 ? (
        appliedUsers.exams_taken.map((info, index) => {
            // This block runs for every object inside the array
            return (
                <li key={info.id || index}>
                    <div className="long">
                        {/* Index + 1 ensures the list is numbered 1, 2, 3... */}
                        <span>{index + 1}.</span>
                        <p>
                            {/* Accessing the correct key: exam_title */}
                            {info.exam_title}
                            <br />
                            <span>Attempt: {info.attempt_number}</span>
                        </p>
                    </div>
                    <div className="exam-status">
                        <span className="score">{info.score}%</span>
                        {/* Optional: Add a badge for Pass/Fail */}
                        <small style={{ color: info.passed ? 'green' : 'red', display: 'block' }}>
                            {info.passed ? "Passed" : "Failed"}
                        </small>
                    </div>
                </li>
            );
        })
    ) : (
        <p className="no-data">No exam records available for this student.</p>
    );





    const enrolledCourseList = appliedUsers?.enrolled_courses?.length > 0 ? (
        appliedUsers.enrolled_courses.map((info, index) => {
            // This block runs for every object inside the array
            return (
                <li key={info.id || index}>
                    <div className="long">
                        <span>{index + 1}.</span>
                        <p> course ID = {info.course}<br />
                            <span>Date = {info.enrollment_date}</span>
                        </p>
                    </div>
                </li>
            );
        })
    ) : (
        <p className="no-data">Student hasnt enrolled .</p>
    );




    const InterestedCourseList = appliedUsers?.interested_courses?.length > 0 ? (
        appliedUsers.interested_courses.map((info, index) => {
            // info = the whole object containing id, student, course, and date
            return (
                <li key={info.id || index}>
                    <div className="long">
                        <span>{index + 1}.</span>
                        <p>
                            {/* Go inside the course object to get the title */}
                            {info.course?.title}
                            <br />
                            {/* Displaying tags or a static label */}
                            <span>{info.course?.tags || "GIS - Online"} - {info.course?.labels}</span>
                        </p>
                    </div>
                </li>
            );
        })
    ) : (
        <p className="no-data">No interested courses available for this student.</p>
    );


    const savelist = appliedUsers?.saved_courses?.length > 0 ? (
        appliedUsers.saved_courses.map((info, index) => {
            // This block runs for every object inside the array
            return (
                <li key={info.id || index}>
                    <div className="long">
                        <span>{index + 1}.</span>
                        <p> course ID = {info.course}<br />
                            <span>Date = {info.saved_date}</span>
                        </p>
                    </div>
                </li>
            );
        })
    ) : (
        <p className="no-data">No exam records available for this student.</p>
    );



    return (
        <div className="dashboard">
            <DashSearchHeader onResize={handleResize} />
            <TutorDashMenu />
            <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 10px)`, overflow: 'hidden' }}>
                <div className="main_dashboard_body">

                    {/* 🎯 Left Menu/Sidebar (Student List) */}
                    {/* <div className="main_dash_menu_cover">
                    <div className="main_dash_menu">
                        <div className="main_dash_container">
                            {AppliedUserList}
                        </div>
                    </div>
                </div> */}





                    {/* 🎯 Main Content (Student Profile Viewer) */}
                    <div className="main_dash_content" style={{ marginTop: "0px" }}>
                        <div className="profile_body">
                            <h2>
                                <span> {formData.firstname} {formData.lastname} Profile</span>
                                <Link to="/tutor_library"><button className="save" >Back</button></Link>
                            </h2>

                            <p className={formData.error ? 'error_active' : 'error_hidden'}>{formData.error}</p>

                            <div className="profile_info one">
                                <section className="profile_pic">
                                    <section
                                        className="image_cover"
                                        onDragOver={handleDragOver}
                                        onDrop={handleDrop}
                                    >
                                        {formData.selectedImage ? (
                                            <img src={formData.selectedImage} alt="profile_picture" />
                                        ) : (
                                            <img src={PlaceholderImage} alt="profile_picture" />
                                        )}
                                        <button onClick={handleButtonClick}><TbCameraPlus /></button>
                                        <input
                                            type="file"
                                            id='thumb'
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            disabled
                                        />
                                    </section>
                                </section>

                                {/* --- Input Fields Displaying formData --- */}
                                <div className="profile_name">
                                    <label htmlFor="firstname">First Name</label><br />
                                    <input
                                        placeholder="First Name"
                                        name="firstname"
                                        id="firstname"
                                        value={formData.firstname}
                                        onChange={handleInputChange}
                                        disabled
                                    /><br /><br />
                                </div>

                                <div className="profile_name">
                                    <label htmlFor="lastname">Last Name</label><br />
                                    <input
                                        placeholder="Last Name"
                                        name="lastname"
                                        id="lastname"
                                        value={formData.lastname}
                                        onChange={handleInputChange}
                                        disabled
                                    /><br /><br />
                                </div>

                                <label htmlFor="middle_name">Middle Name</label><br />
                                <input
                                    placeholder="Middle Name"
                                    name="middle_name"
                                    id="middle_name"
                                    value={formData.middle_name}
                                    onChange={handleInputChange}
                                    disabled
                                /><br /><br />

                                <label htmlFor="email">Email</label><br />
                                <input
                                    placeholder="@gmail.com"
                                    autoComplete="email"
                                    name="email"
                                    id="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    disabled
                                /><br /><br />

                                <label htmlFor="phone">Phone</label><br />
                                <input
                                    placeholder="0900000000"
                                    autoComplete="phone"
                                    type="number"
                                    min="0"
                                    name="phone"
                                    id="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    disabled
                                /><br /><br />

                                <label htmlFor="address">Address</label><br />
                                <input
                                    placeholder="No 9 unknown street"
                                    name="address"
                                    id="address"
                                    value={formData.address}
                                    onChange={handleInputChange}
                                    disabled
                                /><br /><br />

                            </div>
                            <div className="profile_info two">

                                <label htmlFor="gender">Gender</label><br />
                                <select
                                    name="gender"
                                    id="gender"
                                    value={formData.gender || ""}
                                    onChange={handleInputChange}
                                    disabled
                                >
                                    <option value="">Select Gender</option>
                                    <option value='Male'>Male</option>
                                    <option value='Female'>Female</option>
                                </select><br /><br />

                                {/* Country Select */}
                                <label htmlFor="country">Country</label><br />
                                <select
                                    name="selectedCountry"
                                    value={formData.selectedCountry || ""}
                                    id="country"
                                    onChange={handleCountryChange}
                                    disabled
                                >
                                    <option value="">Select Country</option>
                                    {countries.map((country) => (
                                        <option key={country.isoCode} value={country.isoCode}>
                                            {country.name}
                                        </option>
                                    ))}
                                </select><br /><br />

                                {/* State Select */}
                                <label htmlFor="city">State</label><br />
                                <select
                                    name="selectedState"
                                    value={formData.selectedState || ""}
                                    id="city"
                                    disabled
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select State</option>
                                    {formData.states.map((state) => (
                                        <option key={state.isoCode} value={state.isoCode}>
                                            {state.name}
                                        </option>
                                    ))}
                                </select><br /><br />

                                <label htmlFor="specialisation">Area of Specialisation</label><br />
                                <input
                                    placeholder="list specialisation"
                                    name="specialisation"
                                    id="specialisation"
                                    value={formData.specialisation}
                                    onChange={handleInputChange}
                                    disabled
                                /><br /><br />

                                <label htmlFor="venue">Select your preferred training venue</label>
                                <select
                                    name="venue"
                                    id='venue'
                                    value={formData.venue}
                                    onChange={handleInputChange}
                                    disabled
                                >
                                    <option value="">Select training venue</option>
                                    <option value="Online">Online</option>
                                    <option value="Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos">Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awafemi Awolowo Way, Ikeja, Lagos</option>
                                    <option value="6th floor, Nigeria Reinsurance Corporation building, Plot 784A Herbert Macaulay Way, North, Abuja.">6th floor, Nigeria Reinsurance Corporation building, Plot 784A Herbert Macaulay Way, North, Abuja.</option>
                                </select><br /><br />
                            </div>
                        </div>


                        {/* --- Side by Side Panels (Applied Courses / Exam Taken) --- */}
                        <div className="side_by_side">
                            <div className="side_by_side_cover">
                                <div className="side_container left">
                                    <h2>Enrolled Courses <button onClick={() => IdentifyStudent(student_id)}>Enroll</button></h2>
                                    <div className="side_cover">
                                        {/* <li><div className="long"><span>1.</span><p > what is your favorite course <br /><span>GIS - Online</span></p></div></li> */}
                                        {enrolledCourseList}
                                    </div>
                                </div>
                                <div className="side_container right">
                                    <h2>Exam Taken </h2>
                                    <div className="side_cover">
                                        {/* <li><div className="long"><span>1.</span><p > what is your favorite course <br /><span>GIS - Online</span></p></div> <span>80%</span></li> */}
                                        {examlist}
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="side_by_side">
                            <div className="side_by_side_cover">
                                <div className="side_container left">
                                    <h2>Interested  Courses</h2>
                                    <div className="side_cover">
                                        {/* <li><div className="long"><span>1.</span><p > what is your favorite course <br /><span>GIS - Online</span></p></div></li> */}
                                        {InterestedCourseList}
                                    </div>
                                </div>
                                <div className="side_container right">
                                    <h2>Saved Courses </h2>
                                    <div className="side_cover">
                                        {/* <li><div className="long"><span>1.</span><p > what is your favorite course <br /><span>GIS - Online</span></p></div> <span>80%</span></li> */}
                                        {savelist}
                                    </div>
                                </div>

                                
                            </div>
                        </div>



                    </div>
                </div>
            </div>
        { activeModifier ? <ModifyStudent studentId={student_id} closeform={RemoveModifier} /> : null }

        </div>
    )
}

export default StudentList;